import { render, staticRenderFns } from "./sidebarDeposit.vue?vue&type=template&id=4a68d10e&"
import script from "./sidebarDeposit.vue?vue&type=script&lang=js&"
export * from "./sidebarDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports